/* eslint-disable import/prefer-default-export */
import { useDispatch } from "react-redux";
import FormActions from "redux-react/actions/formAction";

export const useFormActions = () => {
	const dispatch = useDispatch();

	const getItemsFromCollection = async (collection, datas, cluster = {}) => {
		return new Promise(resolve => {
			dispatch(
				FormActions.getItemsFromCollection(
					collection,
					datas,
					res => {
						resolve(res?.items || []);
					},
					cluster
				)
			);
		});
	};

	const getItemByID = (id, target, routeDictionary, onSuccess, flag = false, account = false) => {
		dispatch(FormActions.getItemByID(id, target, routeDictionary, onSuccess, flag, account));
	};

	const getItemEmpty = (collection, routeDictionary, onSuccess) => {
		dispatch(FormActions.getItemEmpty(collection, routeDictionary, onSuccess));
	};

	const deleteItem = (id, target, actions, onSuccess) => {
		dispatch(FormActions.deleteItem(id, target, actions, onSuccess));
	};

	const addItem = (data, onSuccess, onError) => {
		dispatch(FormActions.addItemEmpty(data, onSuccess, onError));
	};

	const updateItem = (id, data, onSuccess, onError) => {
		dispatch(FormActions.updateItem(id, data, onSuccess, onError));
	};

	const importCSV = (data, onSuccess) => {
		dispatch(FormActions.importCSV(data, onSuccess));
	};

	return {
		getItemByID,
		getItemEmpty,
		deleteItem,
		addItem,
		updateItem,
		importCSV,
		getItemsFromCollection
	};
};
